import React, { Component } from 'react'

import About from '../components/About'

export default class about extends Component {
  render() {
    return (
      <About/>
    )
  }
}
